// Tickets de la org (mcp_django apps/api/routers/tickets.py, auth JWT):
//   GET /api/v1/tickets/?page_size=…&status=…   → { count, results: TicketListItem[] }
//   GET /api/v1/tickets/{id}                    → { ticket, actions, approvals }
// El backend fuerza la org del JWT; aquí no se elige org.

import { useQuery } from '@tanstack/react-query';

import { djangoApiCall } from '@/lib/api';

export interface TicketItem {
  id: string;
  code: string;
  type: string;
  severity: string;
  status: string;
  title: string;
  detected_at: string;
  scope?: string;
}

export interface TicketFull extends TicketItem {
  description?: string;
  proposed_action?: string;
  detected_by?: string;
  detection_signal?: Record<string, unknown> | null;
  source_repo?: string;
  pr_url?: string;
  resolved_at?: string | null;
}

export interface TicketDetail {
  ticket: TicketFull;
}

export function useTickets(pageSize = 100) {
  return useQuery<{ count: number; results: TicketItem[] }>({
    queryKey: ['orion-shell', 'tickets', pageSize],
    queryFn: () => djangoApiCall(`/tickets/?page_size=${pageSize}`),
  });
}

export function useTicket(id: string | null) {
  return useQuery<TicketDetail>({
    queryKey: ['orion-shell', 'ticket', id],
    queryFn: () => djangoApiCall<TicketDetail>(`/tickets/${encodeURIComponent(id!)}`),
    enabled: !!id,
  });
}

export const STATUS_LABEL: Record<string, string> = {
  detected: 'Recibido',
  analyzed: 'Analizado',
  proposed: 'Propuesto',
  approved: 'Aprobado',
  in_progress: 'En curso',
  pr_open: 'Cambio propuesto (PR)',
  in_staging: 'En pruebas',
  staging_validated: 'Validado en pruebas',
  in_prod: 'Publicado',
  monitoring: 'En observación',
  resolved: 'Resuelto',
  rolled_back: 'Revertido',
  dismissed: 'Descartado',
  failed: 'Falló',
};

export const CERRADOS = new Set(['resolved', 'dismissed', 'rolled_back', 'failed']);

export const TYPE_LABEL: Record<string, string> = {
  bug: 'Falla',
  incident: 'Incidente',
  improvement: 'Mejora',
  feature_request: 'Función nueva',
  config_change: 'Configuración',
  data_correction: 'Corrección de datos',
  security: 'Seguridad',
  decision: 'Decisión',
  strategy_proposal: 'Propuesta',
};

export const SEVERITY_LABEL: Record<string, string> = { low: 'Baja', medium: 'Media', high: 'Alta', critical: 'Crítica' };
